<ng-container *ngIf="selectedMachineTotals$ | async as selectedMachineTotals">
  <table class="machine-totals-table">
    <thead>
      <th>
        <span class="totals-item-head">total jobs</span>
      </th>
      <th>
        <span class="totals-item-head">total time (dd:hh:mm:ss)</span>
      </th>
      <th>
        <span class="totals-item-head">total cut (m)</span>
      </th>
      <th>
        <span class="totals-item-head">total crease (m)</span>
      </th>
      <th>
        <span class="totals-item-head">average (m)</span>
      </th>
    </thead>
    <tbody>
      <tr>
        <td>
          <span class="totals-item">{{ selectedMachineTotals.count }}</span>
        </td>
        <td>
          <span class="totals-item">{{
            selectedMachineTotals.totalTimeAsHHmmss
          }}</span>
        </td>
        <td>
          <span class="totals-item">{{
            selectedMachineTotals.cutMetersAsString
          }}</span>
        </td>
        <td>
          <span class="totals-item">{{
            selectedMachineTotals.creaseMetersAsString
          }}</span>
        </td>
        <td>
          <span class="totals-item">{{
            selectedMachineTotals.cutMetersPlusCreaseMetersDividedByTotalTimeAsString
          }}</span>
        </td>
      </tr>
    </tbody>
  </table>
</ng-container>
